import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { compose } from "redux";
import ActionButton from "../../components/common/ActionButton";
import ActionHeading from "../../components/common/ActionHeading";
import QuestionsList from "../../components/questions/QuestionListing";
import QuestionFilter from "../../components/questions/QuestionFilter";
import Container from "../../components/common/Container";
import HeaderBar from "../../components/common/HeaderBar";
import PageHeading from "../../components/common/PageHeading";
import { getLoggedInUser } from "../../reducers";
import { clearIcon, helpIcon } from "../../util/icons";
import usePersistedState from "../../util/persistedState";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
  contents: {
    marginBottom: "75px",
  },
}));

const defaultFilter = {
  workItemId: "",
  audience: "UNANSWERED_CURRENT_USER",
  includeTemplates: false,
};

const Index = ({ loggedInUser }) => {
  const classes = useStyles();
  const [sortBy, setSortBy] = usePersistedState(
    `questions-sort-${loggedInUser.email}`,
    {
      field: "workItemTitle",
      direction: "asc",
    }
  );
  const [filter, setFilter] = usePersistedState(
    `questions-filter-${loggedInUser.email}`,
    defaultFilter,
    ["textSearch"]
  );

  const clearFilter = () => setFilter(defaultFilter);

  const updateFilter = (key, value) => {
    setFilter({
      ...filter,
      [key]: value,
    });
  };

  return (
    <div className={classes.root}>
      <HeaderBar fluid>
        <ActionHeading
          heading={<PageHeading icon={helpIcon()} heading="Questions" />}
          actions={[
            <ActionButton
              key="clearFilter"
              tooltip="Clear filters"
              icon={clearIcon()}
              onClick={clearFilter}
              data-cy="clear-filters-button"
            />,
          ]}
        />
      </HeaderBar>
      <QuestionFilter filter={filter} updateFilter={updateFilter} />
      <Container fluid className={classes.contents} data-cy="questions">
        <QuestionsList
          filter={filter}
          clearFilter={clearFilter}
          sortBy={sortBy}
          updateSort={setSortBy}
        />
      </Container>
    </div>
  );
};

Index.propTypes = {
  loggedInUser: PropTypes.object,
};

Index.defaultProps = {
  loggedInUser: null,
};

const mapStateToProps = (state) => ({
  loggedInUser: getLoggedInUser(state),
});

export default compose(connect(mapStateToProps))(Index);
